"use client"

import * as React from "react"
import type { Editor } from "@tiptap/react"

import { useTiptapEditor } from "../../../hooks/use-tiptap-editor"

import type { ButtonProps } from "../../../components/tiptap-ui-primitive/button"
import { Button } from "../../../components/tiptap-ui-primitive/button"

export interface LinkToolbarButtonProps extends Omit<ButtonProps, "type"> {
  editor?: Editor | null
}

export const LinkAddButton = React.forwardRef<
  HTMLButtonElement,
  LinkToolbarButtonProps
>(({ editor: providedEditor, onClick, children, ...buttonProps }, ref) => {
  const { editor } = useTiptapEditor(providedEditor)

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      onClick?.(event)
      if (event.defaultPrevented || !editor) return

      const url = prompt("URL do link:")
      if (!url) return

      editor.chain().focus().extendMarkRange("link").setLink({ href: url }).run()
    },
    [editor, onClick]
  )

  return (
    <Button
      type="button"
      data-style="ghost"
      role="button"
      tabIndex={-1}
      aria-label="Adicionar link"
      tooltip="Adicionar link"
      onClick={handleClick}
      {...buttonProps}
      ref={ref}
    >
      {children ?? <i className="fa-solid fa-link"></i>}
    </Button>
  )
})

LinkAddButton.displayName = "LinkAddButton"

export const LinkRemoveButton = React.forwardRef<
  HTMLButtonElement,
  LinkToolbarButtonProps
>(({ editor: providedEditor, onClick, children, ...buttonProps }, ref) => {
  const { editor } = useTiptapEditor(providedEditor)

  const handleClick = React.useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      onClick?.(event)
      if (event.defaultPrevented || !editor) return

      editor.chain().focus().unsetLink().run()
    },
    [editor, onClick]
  )

  return (
    <Button
      type="button"
      data-style="ghost"
      role="button"
      tabIndex={-1}
      aria-label="Remover link"
      tooltip="Remover link"
      onClick={handleClick}
      {...buttonProps}
      ref={ref}
    >
      {children ?? <i className="fa-solid fa-link-slash"></i>}
    </Button>
  )
})

LinkRemoveButton.displayName = "LinkRemoveButton"
